<template>
  <modal
    class="addNewRetainershipModal"
    name="updateBRLModal"
    transition="pop-out"
    :width="modalWidth"
    :height="380"
    @closed="closed"
    @opened="opened"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closed"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="mt-2 add__retainership__header">
          <span>
            <img src="@/assets/img/deal.png" width="50px" />
          </span>
          <span>
            {{ $t("text.reorderLevel.editRe") }}
          </span>
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="mt-3 form_input_section">
              <div class="mt-3 input__block">
                <select v-model="trlDet.productId" @change="getProductCapacity">
                  <option value="null" selected disabled>
                    {{ $t("text.priceManagement.selectProduct") }}
                  </option>
                  <option
                    :value="product.id"
                    v-for="(product, index) in productList"
                    :key="index"
                  >
                    <span>
                      {{ product.productName }}
                    </span>
                  </option>
                </select>
              </div>
              <label
                v-if="showProCap"
                class="text-success d-flex justify-content-start"
                >{{ $t("text.reorderLevel.proCap") }}:
                {{ productCapacity }}</label
              >
            </div>

            <div class="mt-3 form_input_section">
              <label class="d-flex justify-content-start" for="">{{
                $t("text.reorderLevel.title")
              }}</label>
              <div class="input__block" ref="phone_input_div">
                <input
                  type="number"
                  placeholder="reorder level"
                  class="form-control w-100"
                  v-model="trlDet.reorderLevel"
                />
              </div>
            </div>

            <div class="mt-5 text-center">
              <button
                class="btn dealers_btn"
                @click="updateBRL"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.detailAction.update") }}
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="19px"
                  class="ml-3 loader"
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
const MODAL_WIDTH = 700;
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "updateBRLModal",
  props: ["trlDet", "industryBranchId"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      productList: [],
      productCapacity: "",
      showProCap: false,
    };
  },
  // watch: {
  //   companyId(oldValue, newValue) {
  //     this.getCompanyBranchDealers();
  //   },
  // },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    opened() {
      this.getProducts();
      this.getProductCapacity();
    },
    closed() {
      this.$modal.hide("updateBRLModal");
      this.trlDet = {};
      this.showProCap = false;
    },

    getProducts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/Branch/${this.industryBranchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.productList = response.data;
          // console.log(response);
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },

    getProductCapacity() {
      // $(".loader2").show();
      this.showProCap = false;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Products/ProductCapacity?Id=${this.trlDet.productId}&BranchId=${this.industryBranchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          // $(".loader2").hide();
          this.showProCap = true;
          this.productCapacity = response.data.totalCapacity;
        })
        .catch((error) => {
          // this.showLoader = false;
        });
    },

    updateBRL(event) {
      event.preventDefault();

      if (this.trlDet.productId == "selectProduct") {
        this.$toast.open({
          message: this.$t("text.reorderLevel.selPro"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.trlDet.reorderLevel) {
        this.$toast.open({
          message: this.$t("text.reorderLevel.inputRL"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      $(".loader").show();
      this.isButtonDisabled = true;

      const data = {
        reorderLevel: parseFloat(this.trlDet.reorderLevel),
        productId: parseFloat(this.trlDet.productId),
        branchId: this.industryBranchId,
      };

      this.axios
        .put(
          `${configObject.apiBaseUrl}/Products/ProductReorderLevels/Edit/${this.trlDet.id}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.products.updated"),
            type: "success",
            duration: 3000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.trlDet = {};
          this.$modal.hide("updateBRLModal");
          this.$eventHub.$emit("getBRL");
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast(error.response.data.message, {
            type: "error",
            timeout: 3000,
          });
        });
    },
  },
};
</script>
